import { Box, Container, Stack } from "@mui/material";

import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import { Faq } from "./Faq";
import { GetStarted } from "./GetStarted";
import { Overview } from "./Overview";

const interSectionSpacing = 6;
const maxWidth = 1200;

const Fsk8sUpsell = () => {
  const customerHasEntitlement = useIsFeatureEntitled("lens:k8s");

  return (
    <>
      <Container>
        <Box
          sx={{
            maxWidth,
            mb: interSectionSpacing,
            mx: "auto",
            mt: 8,
          }}
        >
          <Stack spacing={6}>
            <Overview />
            {customerHasEntitlement && <GetStarted />}
          </Stack>
        </Box>
      </Container>
      <Box
        width="100%"
        sx={{
          // Undo MainLayout default padding
          mb: "-80px",
          pb: "80px",

          px: 2,
          pt: interSectionSpacing,
          // background: theme.palette.general.backgroundDark,
        }}
      >
        <Box sx={{ mx: "auto", maxWidth }}>
          <Faq />
        </Box>
      </Box>
    </>
  );
};

export default Fsk8sUpsell;
